// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3bEYG","emails":"CreateEditClinics_emails__2cMgn","emailTagLabel":"CreateEditClinics_emailTagLabel__2YBgG"};